import { Component, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { NovaMatIconRegistryService } from '../../services/mat-icon-registry.service';

@Component({
    selector: 'aya-new-version-message',
    standalone: true,
    imports: [MatIconModule, MatButtonModule],
    templateUrl: './new-version-message.component.html',
    styleUrls: ['./new-version-message.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class NewVersionMessageComponent {
    constructor(private readonly matIconRegistry: NovaMatIconRegistryService) {
        this.matIconRegistry.addSvgIcon('surprised', 'assets/images/svg/surprise-regular.svg');
    }

    refreshPage() {
        window.location.reload();
    }
}
